export default "__VITE_ASSET__Cb1_gzE$__"